import { render } from "./generauxTemplate.vue?vue&type=template&id=f5a3b40e&scoped=true"
import script from "./generauxTemplate.vue?vue&type=script&lang=js"
export * from "./generauxTemplate.vue?vue&type=script&lang=js"

import "./generauxTemplate.vue?vue&type=style&index=0&id=f5a3b40e&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a3b40e"]])

export default __exports__